import type { AdminQuestion } from "../../types";
import { StatusBadge } from "./StatusBadge";
import { formatTime } from "../../lib/format";

export function QuestionList({
  questions,
  selectedId,
  onSelect,
}: {
  questions: AdminQuestion[];
  selectedId: string | null;
  onSelect: (id: string) => void;
}) {
  if (questions.length === 0) {
    return <p className="empty">該当する質問はありません</p>;
  }
  return (
    <ul className="question-list">
      {questions.map((q) => (
        <li key={q.id}>
          <button
            type="button"
            className={`question-list-item ${q.id === selectedId ? "selected" : ""}`}
            onClick={() => onSelect(q.id)}
          >
            <div className="qli-top">
              <span className="qli-time">{formatTime(q.created_at)}</span>
              <StatusBadge status={q.status} />
            </div>
            <div className="qli-text">{truncate(q.question_text, 48)}</div>
            <div className="qli-meta">
              {q.display_name ?? "（表示名なし）"}
              {q.wants_consultation && <span className="qli-flag">相談希望あり</span>}
            </div>
          </button>
        </li>
      ))}
    </ul>
  );
}

function truncate(s: string, n: number): string {
  return s.length > n ? `${s.slice(0, n)}…` : s;
}
